/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_AllowedRoleMappingGroupedVm } from '../models/PagedResultDto_AllowedRoleMappingGroupedVm';
import type { PagedResultDto_AllowedRoleMappingsVm } from '../models/PagedResultDto_AllowedRoleMappingsVm';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AllowedRoleMappingService {

    /**
     * @param sourceCompanyId 
     * @param destinationRoleId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AllowedRoleMappingsVm OK
     * @throws ApiError
     */
    public static getApiCustomerApiCustomerSuccessAllowedRoleMapping(
sourceCompanyId?: string,
destinationRoleId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AllowedRoleMappingsVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/customer-success/allowed-role-mapping',
            query: {
                'SourceCompanyId': sourceCompanyId,
                'DestinationRoleId': destinationRoleId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sourceCompanyId 
     * @param destinationRoleId 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_AllowedRoleMappingGroupedVm OK
     * @throws ApiError
     */
    public static getApiCustomerApiV2CustomerSuccessAllowedRoleMapping(
sourceCompanyId?: string,
destinationRoleId?: string,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_AllowedRoleMappingGroupedVm> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/v2/customer-success/allowed-role-mapping',
            query: {
                'SourceCompanyId': sourceCompanyId,
                'DestinationRoleId': destinationRoleId,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
